<div class="panel-header-container" [formGroup]="taxMaterialRateFormGroup">
    <div class="panel-header-row">

        <button mat-icon-button (click)="isTaxMaterialRateExpanded = !isTaxMaterialRateExpanded" class="button-expand-collapse">
            <mat-icon class="icon-expand-collapse">
                {{isTaxMaterialRateExpanded ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <table class="full-width" [formGroup]="taxMaterialRateFormGroup.controls.headerRow">
            <tr class="custom-table-row">
                <td class="estimate-table-column width-190">{{ headerRow.description.value || ('TAX_MATERIAL_RATE' | translate) }}</td>
                <td class="estimate-table-column width-110">
                    {{ headerRow.cost.value | multilingualCurrency }}
                </td>
                <td class="estimate-table-column width-70"></td>
                <td class="estimate-table-column width-70">
                    {{ headerRow.tdcPercentage.value | decimalPrecision }}%
                </td>
                <td class="estimate-table-column width-70"></td>
                <td class="estimate-table-column width-210 padding-gm"></td>
                <td class="estimate-table-column width-110">
                    {{ headerRow.sellPrice.value | multilingualCurrency }}
                </td>
            </tr>
        </table>
    </div>

    <div *ngIf="isTaxMaterialRateExpanded">

        <div class="table-container margin-left-28">
            <table class="full-width">
                <tr class="table-row-container" *ngFor="let rowGroup of taxMaterialRateFormArray.controls; let i = index; trackBy: trackByTaxMaterialRateIndex" [formGroup]="rowGroup">
                    <td class="estimate-table-column width-190">
                        <span class="width-120">{{ rowGroup.controls.name.value | translate }}</span>
                        <mat-form-field class="no-padding-input" appearance="outline" class="mat-input-alignment width-70" [class.collab-sapsub-disabled]="isCollaborativeNotEdit">
                            <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.taxRateConfig" inputmode="decimal" formControlName="rate" class="input-alignment" />
                        </mat-form-field>
                    </td>
                    <td class="estimate-table-column width-110">
                        {{ rowGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ rowGroup.controls.tdcPercentage.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-210 padding-gm"></td>
                    <td class="estimate-table-column width-110">
                        {{ rowGroup.controls.sellPrice.value | multilingualCurrency }}
                    </td>
                </tr>
            </table>
        </div>

    </div>
</div>
